import React, { Component, useEffect, useState } from 'react';
import SpendingPreferencesView from './SpendingPreferencesView';
import crmservices from '../../wsclient/crmservices';
import { isValidEmail } from '../../utils/util';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import Loading from '../../components/Loading';
import { getAppCfg } from '../../utils/common';

function SpendingPreferencesController(props) {

    

    const [showLoading, onShowLoading] = useState(false);
    const [showLoadingOTP, onShowLoadingOTP] = useState(false);
    const [setting, setSetting] = useState({
            enable_automatic_spend: false,
            minimum_wallet_balance: 0,
            from_purchase_amount: 0,
        });
    const [editable, setEditable] = useState(false);
    const [rewards, setRewards] = useState(null);
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const [merchants, setMerchants] = useState([]);
    const [any_purchase, setAnyPurchase] = useState(true);
    const [any_purchase_collect_on, setAnyPurchaseCollectOn] = useState(undefined);
    const [contact_otp, setConactOtp] = useState(null);
    const [request_spend_amount, setRequestSpendAmount] = useState(null);
    const [isValueNull, setIsValueNull] = useState(null);
    const [showRequestOTP, onShowRequestOTP] = useState(null);
    const appConfig = getAppCfg();
    const automatic_spend_options = appConfig.features && appConfig.features.rewards_details && appConfig.features.rewards_details.automatic_spend_options ? appConfig.features.rewards_details.automatic_spend_options : null;

    useEffect(()=>{
        init();
    },[]);

    const init = async() =>{
        onShowLoadingOTP(true);
            await onLoadRewards();
            await getContactOTP();
        onShowLoadingOTP(false);
    }
    const getContactOTP = async() =>{
        try {
            let result = await crmservices.contacts.getContactTokens();
            if (result.code == 'OK') {
                let data = result.data && result.data.content && result.data.content.length > 0 ? result.data.content.sort(sortByExpires) : [];
                console.log('data:',data);
                let content = data.length > 0 ? data[0] : null
                setConactOtp(content);    
            }
        } catch (error) {
            console.log(" get contact otp:".error);
        }
    }
    const sortByExpires = (n1, n2) =>{
        if (n1.expiration > n2.expiration)
            return -1;
        else if (n1.expiration < n2.expiration)
            return 1;
        else return 0;
    }
    const setValue = (rewards) =>{
    //    / let rewards = rewards;
        if (rewards && rewards.automatic_spend_settings) {
            let automatic_spend_settings = rewards.automatic_spend_settings
            setSetting(prevState=>({
                ...prevState,
                enable_automatic_spend: rewards.automatic_spend_settings.enable_automatic_spend,
                minimum_wallet_balance: automatic_spend_settings.minimum_wallet_balance, 
                from_purchase_amount: automatic_spend_settings.from_purchase_amount
            }))
        }
    }

    const onLoadRewards = async() =>{
        onShowLoading(true);
        try {
            let result = await crmservices.account.getRewards();
            //console.log('result=== ',result)
            if (result.code == 'OK') {
                setRewards(result.data);
                setValue(result.data)
            }
        } catch (error) {
            console.log("getPrimaryAccount exception:", error);
        }
        onShowLoading(false);
    }

    const onHandleChange = (target, value) =>{
        if(target==='request_spend_amount'){
            setRequestSpendAmount(value);
        }
        else{
            setIsValueNull(false);
            setSetting(prevState =>({
                ...prevState,
                [target]: value
            }))
        }

    }
    const onSwitchAutomaticSpend = async (status) =>{
        setSetting(prevState=>({
            ...prevState,
            enable_automatic_spend: status
        }))

        if (status == true) {
        } else {
            onShowLoading(true);
            await onUpdateAccountRewards({ enable_automatic_spend: false })
            onShowLoading(false);
        }
    }
    const onUpdateAccountRewards = async(params) =>{
        try {
            let result = await crmservices.account.updateAccountRewards(params);
            if (result.code == 'OK') {
                await onLoadRewards();
                setEditable(false);
                showAlert( t('SUCCESS'), t('UPDATE_SPEND_PREFERENCES_SUCCESS'));
            } else {
                showAlert( t('ERROR'), t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            console.log("updateAccountRewards exception:", error);
            showAlert( t('ERROR'), t('EXCEPTION_PROCESS'));
        }
    }
    const onSave = async(value) =>{
        onShowLoading(true)
        await onUpdateAccountRewards(setting)     
        onShowLoading(false);  
    }

    const onRequestSpendOTP = async() =>{
        //console.log('request_spend_amount value==', request_spend_amount)
        onShowRequestOTP(false);
        onShowLoadingOTP(true);
        try {
            let result = await crmservices.contacts.requestContactToken({ spend_amount: request_spend_amount });
            if(result.code=='OK'){
                await getContactOTP();
                setRequestSpendAmount(null);
            }else{
                showAlert(t("ERROR"),t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            console.log(" get contact otp:".error);
        }
        onShowLoadingOTP(false);
    }
    const showAlert = (status, message, title) =>{
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }
    const onCloseAlert = () =>{
        onShowLoading(false);
        setError({
                showAlert: false,
                title: '',
                message: '',
                status: '',
        })
    }
    return (
        <div>
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            
            <SpendingPreferencesView 
                onSave={onSave}
                onEdit={()=>setEditable(true)} 
                open={props.open}
                onClose = {props.onCloseItem}
                any_purchase={any_purchase}
                any_purchase_collect_on={any_purchase_collect_on}
                contact_otp={contact_otp}
                onHandleChange={onHandleChange}
                setting={setting}
                editable={editable}
                isValueNull = {isValueNull}
                showLoading = {showLoading}
                showLoadingOTP = {showLoadingOTP}
                onSwitchAutomaticSpend={onSwitchAutomaticSpend}
                onShowRequestOTP={()=>onShowRequestOTP(!showRequestOTP)}
                showRequestOTP={showRequestOTP}
                onRequestSpendOTP={onRequestSpendOTP}
                request_spend_amount={request_spend_amount}
                />
            {/* <Loading showLoading={showLoading} />     */}
        </div>
    );
}

export default SpendingPreferencesController;